import { render, staticRenderFns } from "./WaitView.vue?vue&type=template&id=4d04b5a7&scoped=true"
var script = {}
import style0 from "./WaitView.vue?vue&type=style&index=0&id=4d04b5a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d04b5a7",
  null
  
)

export default component.exports